export default "__VITE_ASSET__Dr10H84v__"